module.exports = __webpack_public_path__ + "static/churchloopweb-6c0f80ffd0525f52cd6489119494ea11.png";